import { shopId } from "config/const";
import { callFetch, header, idTokenHeader, tokenHeader } from "./utils";

const EndPoint = {
  GetShop: (lineId) =>
    `/linewebhook/shops/shop/${shopId}/oauth/${lineId}/info?options=id,invoiceProvider,payment_services,annotations,contact_href,settings.delivery_fee,branches,delivery_flow,payment_flow`,
  GetProducts: () => `/linewebhook/product/shop/${shopId}`,
  GetCategories: () => `/linewebhook/category/shop/${shopId}`,
  GetCollections: () => `/linewebhook/collection-tag/shop/${shopId}`,
  GetTags: () => `/linewebhook/product-tag/shop/${shopId}`,
  GetImages: ({ title = "", desc = "" }) =>
    `/linewebhook/image/shop/${shopId}?title=${title}&desc=${desc}`,
  GetPages: (actions) =>
    `/linewebhook/page/shop/${shopId}?actions=${actions.join(",")}`,
  GetLandingPage: () => `/linewebhook/landing-page/shop/${shopId}`,
  GetShopI18nEntities: () => `/linewebhook/i18n/shop/${shopId}/entities`,
  GetCollectionProducts: (tagId) =>
    `/linewebhook/collection-tag/shop/${shopId}/${tagId}/products`,
};

// Shop
export function getShop(liffToken, lineId) {
  const uri = EndPoint.GetShop(lineId);
  let settings = {
    method: "POST",
    headers: header,
    body: JSON.stringify({ accessToken: liffToken }),
  };

  return callFetch(uri, settings);
}

export function getProducts(idToken) {
  const uri = EndPoint.GetProducts();
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getCategories(idToken) {
  const uri = EndPoint.GetCategories();
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getCollections(idToken) {
  const uri = EndPoint.GetCollections();
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getTags(idToken) {
  const uri = EndPoint.GetTags();
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getImages(idToken, query = { title: "", desc: "" }) {
  const uri = EndPoint.GetImages(query);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getPages(idToken, actions = []) {
  const uri = EndPoint.GetPages(actions);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getLandingPage(idToken) {
  const uri = EndPoint.GetLandingPage();
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getShopI18nEntities(idToken) {
  const uri = EndPoint.GetShopI18nEntities();
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getCollectionProducts(idToken, tagId) {
  const uri = EndPoint.GetCollectionProducts(tagId);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}
